const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroundWaterReplenishment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 191.74 120.21",
    style: {
      enableBackground: "new 0 0 191.74 120.21"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 11.3386,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M129.59,85c0.29-1.83,0.43-3.68,0.43-5.55c0-5.28-1.12-10.35-3.33-15.08l-0.11-0.23l-1.16-2.21L95.87,5.67L66.32,61.91l-1.16,2.21 l-0.11,0.23c-2.21,4.72-3.33,9.79-3.33,15.08c0,1.86,0.14,3.72,0.43,5.55 M5.67,97.23c6.79,10.48,17.71,17.31,30.07,17.31 s23.29-6.83,30.03-17.4c6.75,10.39,17.67,17.21,30.03,17.21c12.36,0,23.29-6.83,30.1-17.31c6.81,10.48,17.73,17.31,30.09,17.31 c12.36,0,23.28-6.83,30.07-17.31"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroundWaterReplenishment);
export default __webpack_public_path__ + "static/media/ground-water-replenishment.638b041976c3ef3cefd97534c14f4a43.svg";
export { ForwardRef as ReactComponent };